//angular
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'dialog-shortcuts',
  styleUrls: ['./shortcuts.component.scss'],
  templateUrl: './shortcuts.component.html'
})

export class DialogShortcutsComponent implements OnInit {
  customerCardBodyDescription = 'A person or organization that buys goods or services from your store or business.'
  customerCardBodyTitle = 'Customers';
  customerCardBodyImage = 'ico-customers-04.svg';
  customerCardLinkPath = '/main/customers/add';
  customerCardLinkText = 'Create a Customer';
  invoiceCardBodyDescription = 'An invoice is a time-stamped commercial document that itemizes and records a transaction between a buyer and a seller.'
  invoiceCardBodyTitle = 'Invoices';
  invoiceCardBodyImage = 'ico-invoices-03.svg';
  invoiceCardLinkPath = '/main/invoices/add';
  invoiceCardLinkText = 'Create an Invoice';
  productCardBodyDescription = 'An article or substance that is manufactured or refined for sale.'
  productCardBodyTitle = 'Products';
  productCardBodyImage = 'ico-products-03.svg';
  productCardLinkPath = '/main/products/add';
  productCardLinkText = 'Create a Product';
  subscriptionCardBodyDescription = 'A subscription is an arrangement whereby goods, services or stock are sold periodically rather than individually.'
  subscriptionCardBodyTitle = 'Subscriptions';
  subscriptionCardBodyImage = 'ico-subscriptions-03.svg';
  subscriptionCardLinkPath = '/main/subscriptions/add';
  subscriptionCardLinkText = 'Create a Subscription';

  constructor(
    private _dialogRef: MatDialogRef<DialogShortcutsComponent>,
    private _iconRegistry: MatIconRegistry,
    private _router: Router,
    private _sanitizer: DomSanitizer,
  ) {
    this._iconRegistry.addSvgIcon('ico-settings', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-settings-02.svg'));
  }

  closePanel() {
    this._dialogRef.close();
  }

  goToPath(_linkPath) {
    this._dialogRef.close();
    this._router.navigate([_linkPath]);
  }

  ngOnInit(): void {
  }

}
